import { defineStore } from 'pinia';
import router, { constantRoutes, dynamicRoutes } from '@/router';
import store from '@/store';
import { getRouters } from '@/api/menu';
import auth from '@/plugins/auth';
import { RouteRecordRaw } from 'vue-router';
import Layout from '@/layout/index.vue';
import ParentView from '@/components/ParentView/index.vue';
import InnerLink from '@/layout/components/InnerLink/index.vue';
import { ref } from 'vue';
import { createCustomNameComponent } from '@/utils/createCustomNameComponent';
import { applyMenuIconFallbacks } from '@/utils/menuIcon';
// 匹配views里面所有的.vue文件
const modules = import.meta.glob('./../../views/**/*.vue');
export const usePermissionStore = defineStore('permission', () => {
  const routes = ref<RouteRecordRaw[]>([]);
  const addRoutes = ref<RouteRecordRaw[]>([]);
  const defaultRoutes = ref<RouteRecordRaw[]>([]);
  const topbarRouters = ref<RouteRecordRaw[]>([]);
  const sidebarRouters = ref<RouteRecordRaw[]>([]);
  const activeCategory = ref({});
  const isRoutesLoaded = ref(false);
  const fullPath = ref(null);
  // 保存路由
  const sidebarRoutesData = ref<RouteRecordRaw[]>([]);

  const getRoutes = (): RouteRecordRaw[] => {
    return routes.value as RouteRecordRaw[];
  };
  const getDefaultRoutes = (): RouteRecordRaw[] => {
    return defaultRoutes.value as RouteRecordRaw[];
  };
  const getSidebarRoutes = (): RouteRecordRaw[] => {
    return sidebarRouters.value as RouteRecordRaw[];
  };
  const getTopbarRoutes = (): RouteRecordRaw[] => {
    return topbarRouters.value as RouteRecordRaw[];
  };
  const getSidebarRoutesData = (): RouteRecordRaw[] => {
    return sidebarRoutesData.value as RouteRecordRaw[];
  };
  // 当前选中类别
  const getActiveCategory = () => {
    return activeCategory.value;
  };

  // 设置选中类别
  const setActiveCategory = (data) => {
    activeCategory.value = data;
  };
  const setRoutes = (newRoutes: RouteRecordRaw[]): void => {
    addRoutes.value = newRoutes;
    routes.value = constantRoutes.concat(newRoutes);
  };
  const setDefaultRoutes = (newDefaultRoutes: RouteRecordRaw[]): void => {
    defaultRoutes.value = constantRoutes.concat(newDefaultRoutes);
  };
  const setTopbarRoutes = (newTopbarRoutes: RouteRecordRaw[]): void => {
    topbarRouters.value = newTopbarRoutes;
  };
  const setSidebarRouters = (type): void => {
    // 判断是否有选择的类别   没有的话就选中默认的第一个

    if (!activeCategory.value.menuId && JSON.parse(sessionStorage.getItem('toPath')) && !JSON.parse(sessionStorage.getItem('toPath')).meta.noCache) {
      const toPath = JSON.parse(sessionStorage.getItem('toPath'));
      const activeName = toPath?.params?.pathMatch?.[0];
      if (activeName) {
        activeCategory.value = sidebarRoutesData.value.filter((v) => {
          return v.path == `/${ activeName}`;
        })[0];
      }
    }

    if (!activeCategory.value.menuId) {
      activeCategory.value = sidebarRoutesData.value.filter((v) => {
        return v.menuId != null && !v.hidden;
      })[0];
    }

    const resData = sidebarRoutesData.value.filter((v) => {
      return v.menuId == activeCategory.value.menuId;
    });
    resData.forEach((el) => {
      if (el.children) {
        const elPath = el.path.split('/')[1];
        el.children.forEach((v) => {
          const arr = v.path.split('/');
          if (!arr.includes(elPath)) {
            v.path = `${el.path }/${ v.path}`;
          }
        });
      }
    });
    const result = findFirstMenuWithPath(resData[0]?.children);
    if (type == 1 && result?.fullPath) {
      router.push(result.fullPath);
    }
    if (resData[0]?.children) {
      sidebarRouters.value = resData[0].children;
    }
  };
  //
  // 设置默认首页
  const setFullPath = () => {
    let defaultActiveCategory = {};

    defaultActiveCategory = sidebarRoutesData.value.filter((v) => {
      return v.menuId != null && !v.hidden;
    })[0];

    const resData = sidebarRoutesData.value.filter((v) => {
      return v.menuId == defaultActiveCategory.menuId;
    });

    resData.forEach((el) => {
      if (el.children) {
        const elPath = el.path.split('/')[1];
        el.children.forEach((v) => {
          const arr = v.path.split('/');
          if (!arr.includes(elPath)) {
            v.path = `${el.path }/${ v.path}`;
          }
        });
      }
    });
    const result = findFirstMenuWithPath(resData[0]?.children);
    fullPath.value = result?.fullPath || '/index';
  };
  // 点击tags切换菜单  监听是否需要切换  类别
  const visitedViewsRouter = (tag) => {
    activeCategory.value = sidebarRoutesData.value.filter((v) => {
      return v.path == tag.matched[0].path;
    })[0];
    const resData = sidebarRoutesData.value.filter((v) => {
      return v.menuId == activeCategory.value.menuId;
    });
    resData.forEach((el) => {
      if (el.children) {
        const elPath = el.path.split('/')[1];
        el.children.forEach((v) => {
          const arr = v.path.split('/');
          if (!arr.includes(elPath)) {
            v.path = `${el.path }/${ v.path}`;
          }
        });
      }
    });
    if (resData[0].children) {
      sidebarRouters.value = resData[0].children;
    }
  };

  const generateRoutes = async (): Promise<RouteRecordRaw[]> => {
    // if (isRoutesLoaded.value) {
    //   return;
    // }
    const res = await getRouters();
    // isRoutesLoaded.value=true
    const data = res.data;
    // const data = [
    //   {
    //     'menuId': '1',
    //     'name': 'Brand',
    //     'path': 'brand',
    //     'menuType': 'S',
    //     'tagType': '1',
    //     'hidden': false,
    //     'redirect': 'noRedirect',
    //     'component': 'Layout',
    //     'alwaysShow': true,
    //     'meta': {
    //       'title': '品牌管理',
    //       'icon': '#',
    //       'noCache': false,
    //       'link': null
    //     },
    //     'children': [
    //       {
    //         'menuId': '1003',
    //         'name': 'BrandIndex',
    //         'path': 'brandIndex',
    //         'menuType': 'C',
    //         'tagType': '1',
    //         'hidden': false,
    //         'component': 'brand/index',
    //         'meta': {
    //           'title': '品牌概览',
    //           'icon': '#',
    //           'noCache': false,
    //           'link': null
    //         }
    //       },
    //       {
    //         'menuId': '1001',
    //         'name': 'BrandManag',
    //         'path': 'brandManag',
    //         'menuType': 'M',
    //         'tagType': '1',
    //         'hidden': false,
    //         'redirect': 'noRedirect',
    //         'component': 'ParentView',
    //         'alwaysShow': true,
    //         'meta': {
    //           'title': '品牌管理',
    //           'icon': '#',
    //           'noCache': false,
    //           'link': null
    //         },
    //         'children': [
    //           {
    //             'menuId': '1001002',
    //             'name': 'DeptList',
    //             'path': 'deptList',
    //             'menuType': 'C',
    //             'tagType': '1',
    //             'hidden': false,
    //             'component': 'brand/brandManag/deptList',
    //             'meta': {
    //               'title': '员工与部门',
    //               'icon': '#',
    //               'noCache': false,
    //               'link': null
    //             }
    //           },
    //           {
    //             'menuId': '1001003',
    //             'name': 'RoleList',
    //             'path': 'roleList',
    //             'menuType': 'C',
    //             'tagType': '1',
    //             'hidden': false,
    //             'component': 'brand/brandManag/roleList',
    //             'meta': {
    //               'title': '角色管理',
    //               'icon': '#',
    //               'noCache': false,
    //               'link': null
    //             }
    //           }
    //         ]
    //       },
    //       {
    //         'menuId': '1002',
    //         'name': 'StoreManag',
    //         'path': 'storeManag',
    //         'menuType': 'M',
    //         'tagType': '1',
    //         'hidden': false,
    //         'redirect': 'noRedirect',
    //         'component': 'ParentView',
    //         'alwaysShow': true,
    //         'meta': {
    //           'title': '门店管理',
    //           'icon': '#',
    //           'noCache': false,
    //           'link': null
    //         },
    //         'children': [
    //           {
    //             'menuId': '1002001',
    //             'name': 'StoreList',
    //             'path': 'storeList',
    //             'menuType': 'C',
    //             'tagType': '1',
    //             'hidden': false,
    //             'component': 'brand/storeManag/storeList',
    //             'meta': {
    //               'title': '门店管理',
    //               'icon': '#',
    //               'noCache': false,
    //               'link': null
    //             }
    //           },
    //           {
    //             'menuId': '1002002',
    //             'name': 'StoreEmployeeList',
    //             'path': 'storeEmployeeList',
    //             'menuType': 'C',
    //             'tagType': '1',
    //             'hidden': false,
    //             'component': 'brand/storeManag/storeEmployeeList',
    //             'meta': {
    //               'title': '门店员工',
    //               'icon': '#',
    //               'noCache': false,
    //               'link': null
    //             }
    //           }
    //         ]
    //       }
    //     ]
    //   }
    // ];
    const resData = CategoryChildren(JSON.parse(JSON.stringify(data)));
    applyMenuIconFallbacks(resData);
    const sdata = JSON.parse(JSON.stringify(resData));
    const rdata = JSON.parse(JSON.stringify(resData));
    const defaultData = JSON.parse(JSON.stringify(resData));
    const sidebarRoutes = filterAsyncRouter(sdata);
    const rewriteRoutes = filterAsyncRouter(rdata, undefined, true);
    const filteredDefaultRoutes = filterAsyncRouter(defaultData);
    const asyncRoutes = filterDynamicRoutes(dynamicRoutes);
    asyncRoutes.forEach((route) => {
      router.addRoute(route);
    });
    setRoutes(rewriteRoutes);
    // 设置路由
    sidebarRoutesData.value = constantRoutes.concat(sidebarRoutes);
    setFullPath();
    setSidebarRouters(2);

    setDefaultRoutes(sidebarRoutes);
    setTopbarRoutes(filteredDefaultRoutes);
    // 路由name重复检查
    duplicateRouteChecker(asyncRoutes, sidebarRoutes);
    return new Promise<RouteRecordRaw[]>((resolve) => resolve(rewriteRoutes));
  };
  // 3. 递归查找第一个显示的 C 菜单 + 拼接路径
  function findFirstMenuWithPath(menuNodes = [], parentPath = '') {
    for (const node of menuNodes) {
      if (node.hidden || node.menuType === 'F') {
        continue;
      }

      // 拼接当前节点的路径（处理根路径/空路径）
      const currentPath = parentPath ? `${parentPath}${node.path.startsWith('/') ? '' : '/'}${node.path}` : node.path;

      // 找到显示的 C 菜单：返回菜单信息 + 完整路径
      if (node.menuType === 'C') {
        return {
          menu: node,
          fullPath: currentPath,
        };
      }
      // 是 M 目录且有子节点：递归（传递当前拼接的路径）
      if (node.menuType === 'M' && node.children && node.children.length > 0) {
        const foundResult = findFirstMenuWithPath(node.children, currentPath);
        // 子层级找到结果：立即返回
        if (foundResult) {
          return foundResult;
        }
      }
    }
    // 未找到：返回 null
    return null;
  }

  /**
   * 遍历后台传来的路由字符串，转换为组件对象
   * @param asyncRouterMap 后台传来的路由字符串
   * @param lastRouter 上一级路由
   * @param type 是否是重写路由
   */
  const filterAsyncRouter = (asyncRouterMap: RouteRecordRaw[], lastRouter?: RouteRecordRaw, type = false): RouteRecordRaw[] => {
    return asyncRouterMap.filter((route) => {
      if (type && route.children) {
        route.children = filterChildren(route.children, undefined);
      }
      // Layout ParentView 组件特殊处理
      if (route.component?.toString() === 'Layout') {
        route.component = Layout;
      } else if (route.component?.toString() === 'ParentView') {
        route.component = ParentView;
      } else if (route.component?.toString() === 'InnerLink') {
        route.component = InnerLink;
      } else {
        route.component = loadView(route.component, route.name as string);
      }
      if (route.children != null && route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children, route, type);
      } else {
        delete route.children;
        delete route.redirect;
      }
      return true;
    });
  };
  const filterChildren = (childrenMap: RouteRecordRaw[], lastRouter?: RouteRecordRaw): RouteRecordRaw[] => {
    let children: RouteRecordRaw[] = [];
    childrenMap.forEach((el) => {
      el.path = lastRouter ? `${lastRouter.path }/${ el.path}` : el.path;
      if (el.children && el.children.length && el.component?.toString() === 'ParentView') {
        children = children.concat(filterChildren(el.children, el));
      } else {
        children.push(el);
      }
    });

    return children;
  };
  // 处理类别  添加‘/’
  const CategoryChildren = (data: RouteRecordRaw[]) => {
    data.forEach((el) => {
      el.path = `/${ el.path}`;
    });
    return data;
  };
  return {
    routes,
    topbarRouters,
    sidebarRouters,
    defaultRoutes,
    sidebarRoutesData,
    activeCategory,
    isRoutesLoaded,
    fullPath,

    getRoutes,
    getDefaultRoutes,
    getSidebarRoutes,
    getTopbarRoutes,
    getSidebarRoutesData,
    getActiveCategory,

    setRoutes,
    generateRoutes,
    setSidebarRouters,
    setActiveCategory,
    visitedViewsRouter,
  };
});

// 动态路由遍历，验证是否具备权限
export const filterDynamicRoutes = (candidateRoutes: RouteRecordRaw[]) => {
  const permittedRoutes: RouteRecordRaw[] = [];
  candidateRoutes.forEach((candidateRoute) => {
    if (candidateRoute.permissions) {
      if (auth.hasPermiOr(candidateRoute.permissions)) {
        permittedRoutes.push(candidateRoute);
      }
    } else if (candidateRoute.roles && auth.hasRoleOr(candidateRoute.roles)) {
      permittedRoutes.push(candidateRoute);
    }
  });
  return permittedRoutes;
};

export const loadView = (view: any, componentName: string) => {
  let matchedComponent;
  for (const path in modules) {
    const viewsIndex = path.indexOf('/views/');
    let dir = path.substring(viewsIndex + 7);
    dir = dir.substring(0, dir.lastIndexOf('.vue'));
    if (dir === view) {
      matchedComponent = createCustomNameComponent(modules[path], { name: componentName });
      return matchedComponent;
    }
  }
  return matchedComponent;
};

// 非setup
export const usePermissionStoreHook = () => {
  return usePermissionStore(store);
};

interface Route {
  name?: string | symbol;
  path: string;
  children?: Route[];
}

/**
 * 检查路由name是否重复
 * @param localRoutes 本地路由
 * @param remoteRoutes 动态路由
 */
function duplicateRouteChecker(localRoutes: Route[], remoteRoutes: Route[]) {
  // 展平
  function flatRoutes(routeList: Route[]) {
    const flattenedRoutes: Route[] = [];
    routeList.forEach((routeItem) => {
      if (routeItem.children) {
        flattenedRoutes.push(...flatRoutes(routeItem.children));
      } else {
        flattenedRoutes.push(routeItem);
      }
    });
    return flattenedRoutes;
  }

  const allRoutes = flatRoutes([...localRoutes, ...remoteRoutes]);

  const nameList: string[] = [];
  allRoutes.forEach((routeItem) => {
    const routeName = routeItem.name.toString();
    if (routeName && nameList.includes(routeName)) {
      return;
    }
    nameList.push(routeItem.name.toString());
  });
}
